import { SignIn, SignUp } from "@clerk/clerk-react"
import AtlasMark from "@/components/AtlasMark"

export default function AuthPage({ mode }: { mode: "sign-in" | "sign-up" }) {
  return <main className="min-h-screen bg-[#08090d] text-[#f0f1f5] grid lg:grid-cols-[1fr_520px]">
    <section className="hidden lg:flex p-14 flex-col justify-between border-r border-[#1e2130] bg-[radial-gradient(circle_at_20%_10%,rgba(245,158,11,.12),transparent_38%)]">
      <a href="/" className="flex items-center gap-2 text-sm font-semibold"><AtlasMark size={22} /> Atlas by HillPrime Innovations</a>
      <div className="max-w-xl"><p className="eyebrow text-[#f59e0b] mb-4">Your production continues here</p><h1 className="heading-display text-5xl mb-5">Your story, decisions, footage and credits stay with your account.</h1><p className="text-[#9ca3af] text-lg">Sign in securely to return to your project. Atlas never asks you to configure an API URL or access token.</p></div>
      <p className="text-xs text-[#6b7280]">Atlas Studio · Secure account access</p>
    </section>
    <section className="flex flex-col items-center justify-center p-5 sm:p-10">
      <a href="/" className="lg:hidden mb-8 flex items-center gap-2 text-sm font-semibold"><AtlasMark size={22} /> Atlas</a>
      {mode === "sign-in"
        ? <SignIn routing="hash" signUpUrl="/sign-up" fallbackRedirectUrl="/studio" />
        : <SignUp routing="hash" signInUrl="/sign-in" fallbackRedirectUrl="/studio" />}
      <a href="/" className="mt-6 text-xs text-[#9ca3af] hover:text-[#f0f1f5]">← Back to Atlas</a>
    </section>
  </main>
}
